module.exports = __webpack_public_path__ + "media/images/desktop2/2018_AP22167566146868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/desktop2/2018_AP22167566146868.jpg
// module id = 24
// module chunks = 0